import {
    conditionsEndpoint,
    orderProductsEndpoint,
    ordersEndpoint,
    orderStationsEndpoint,
    stationsEndpoint
} from '@/services/adsign-backend/endpoints';
import utils from '@/mixins/utils';
import {PackageTypeShortName, OrderType} from "@/mixins/dictionariesConst";

export default {
    mixins: [utils],
    computed: {
        selectedPackageType() {
            if (this.form.packageTypeId) {
                return this.packageTypes[this.form.packageTypeId];
            }
            return null;
        },
        orderStationsList: {
            get() {
                return !this.orderStationsLoading && this.orderStations || [];
            },
            set(newValue) {
                if (this.allowAddStation) {
                    this.orderStations = newValue;
                }
            }
        },
        includeJoinInvoices() {
            return this.selectedPackageType?.canAllowGroupOrders || false;
        },
        allowAddStation() {
            return this.selectedPackageType?.canAddManuallyStations || false;
        },
        targetGroups() {
            return this.selectedPackageType?.targetGroups || [];
        },
    },
    methods: {
        addProduct() {
            this.$v.form.$touch();
            const productsShare = this.orderProducts.reduce((share, orderProduct) => share + orderProduct.productShare, 0);
            if (!this.$v.form.$invalid && this.form.id && productsShare < 1) {
                this.$router.push(`/campaign/${this.common.id}/order/${this.form.id}/product`);
            }
        },

        addStation() {
            this.$v.form.$touch();
            const stationShare = this.orderStationsList.reduce((share, orderStation) => share + orderStation.stationShare, 0);
            if (!this.$v.form.$invalid && this.form.id && stationShare < 1) {
                this.$router.push(`/campaign/${this.common.id}/order/${this.form.id}/station`);
            }
        },
        addAttachment(){
            this.$v.form.$touch();
            if (!this.$v.form.$invalid && this.form.id) {
                return this.$router.push(`/campaign/${this.common.id}/order/${this.form.id}/attachment`)
            }
        },

        deleteOrderProduct(orderProductId, index, draft) {
            if (orderProductId) {
                orderProductsEndpoint.deleteOrderProduct(this.form.id, orderProductId, draft)
                    .then(() => this.orderProducts.splice(index, 1));
            } else {
                this.orderProducts.splice(index, 1);
            }
        },

        setDefaultValues() {
            if (this.form.orderType.shortName == 'TV') {
                if ((this.form.grpSaleTypeId == '1')){
                    this.form.packageTypeId = 6;
                    this.formDefaultData();
                    this.priceMethod = 'budget'
                    this.form.budget = 0.1;
                }
                else if ((this.form.grpSaleTypeId == '4')) {
                    this.formDefaultData();
                } else {
                    this.form.budget = 0
                }
            }
        },

        formDefaultData(){
            this.form.targetGroupId = ''
            this.form.targetGroupId = this.targetGroups[0].valueId
            this.form.budget = 0
        },

        deleteOrderStation(orderStationId, index, draft) {
            if (orderStationId) {
                orderStationsEndpoint.deleteOrderStation(this.form.id, orderStationId, draft)
                    .then(() => this.orderStations.splice(index, 1));
            } else {
                this.orderStations.splice(index, 1);
            }
        },

        save(draft, updateOrderStationsList = false) {
            if (!this.$v.form.$invalid && this.$v.form.$anyDirty) {
                this.saveOrUpdateOrder(draft).then(() => {
                   if (updateOrderStationsList) {
                        this.updateStationsList();
                    }
                    this.synchronize();
                });
            }
        },

        updateStationsList() {
            this.orderStationsLoading = true;
            orderStationsEndpoint.getOrderStations(this.form.id).then(result => {
                this.orderStations = result.data;
            }).finally(() => this.orderStationsLoading = false);
        },

        updatePaymentTogether(draft) {
            const orderData = {
                campaignId: this.common.id,
                orderType: { valueId: this.form.orderTypeId },
                spotType: { valueId: this.form.spotTypeId },
                grpSaleType: { valueId: this.form.grpSaleTypeId },
                packageType: { valueId: this.form.packageTypeId },
                targetGroup: { valueId: this.form.targetGroupId },
                ...(this.includeJoinInvoices && {paymentTogether: this.form.joinInvoices}),
            }
            if (this.form.id) {
                this.$v.form.$reset();
           
                return ordersEndpoint.updateOrder(this.form.id, orderData, draft);
            }
        },

        saveOrUpdateOrder(draft) {
            const orderData = {
                campaignId: this.common.id,
                orderType: { valueId: this.form.orderTypeId },
                spotType: { valueId: this.form.spotTypeId },
                grpSaleType: { valueId: this.form.grpSaleTypeId },
                packageType: { valueId: this.form.packageTypeId },
                targetGroup: { valueId: this.form.targetGroupId },
                ...(this.includeJoinInvoices && {paymentTogether: this.form.joinInvoices}),
                ...(this.form.priceMethod == 'budget' && {budget: this.removeThousandSeparator(this.form.budget)}),
                ...(this.form.priceMethod == 'grp' && {grp: this.removeThousandSeparator(this.form.grp)}),
            }
            if (this.form.id) {
                this.$v.form.$reset();
                return ordersEndpoint.updateOrder(this.form.id, orderData, draft);
            } else {
                return ordersEndpoint.createOrder(orderData)
                    .then(result => this.form.id = result.data.id)
                    .then(() => this.updateStationsList());
            }
        },

        synchronize() {
            this.$emit('input', {
                ...this.form,
                packageTypeData: this.selectedPackageType,
                condition: this.condition,
                isValid: !this.$v.$invalid,
                orderProducts: this.orderProducts,
                orderStations: (this.allowAddStation && this.orderStationsList || []),
                orderProductsSequences: this.orderProductsSequences
            });
        },

        cancel(draft) {
            if (this.form.id) {
                ordersEndpoint.deleteOrder(this.form.id, draft).then(() => {
                    this.$emit('cancel');
                });
            } else {
                this.$emit('cancel');
            }
        },

        getPriceMethods(allowGrp) {
            if (this.form.grpSaleTypeId) {
                const grpSalesType = this.dictionaries.grpSaleTypes.find((item) => item.valueId === this.form.grpSaleTypeId);
                if (grpSalesType) {
                    const filter = this.priceMethodsFilter[grpSalesType.name.toLowerCase()];
                    if (filter) {
                        return this.dictionaries.priceMethods.filter(filter);
                    }
                }
            }
            return allowGrp ? this.dictionaries.priceMethods : this.dictionaries.priceMethods.filter((item) => item.name !== 'grp');
        },

        getPriceMethodUnit(priceMethodName) {
            return this.dictionaries.priceMethods.find((item) => item.name === priceMethodName)?.unit || '';
        },

        onSaleTypeChange() {
            this.setDefaultValues();
            const priceMethods = this.getPriceMethods(null);
            if (!priceMethods.some((item) => item.name === this.form.priceMethod)) {
                this.form.priceMethod = priceMethods[0].name;
            }
        },

        onPackageTypeChange(draft) {
            this.packageChangeTV();
            this.packageChangeInternet();
            this.packageChangeOOH();
            if (!this.loading && this.form.targetGroupId && !this.targetGroups.some(item => item.valueId == this.form.targetGroupId)) {
                this.form.targetGroupId = this.targetGroups.length && this.targetGroups[0].valueId || null;
            }
            if (!this.allowAddStation && this.form.spotTypeId && this.form.packageTypeId) {
                this.orderStationsLoading = true;
                stationsEndpoint.getStationsBySpotAndPackage(this.form.spotTypeId, this.form.packageTypeId)
                    .then(result => {
                        this.orderStations = result.data.map(item => ({
                            stationId: item.station.id,
                            stationName: item.station.name,
                            stationShare: item.stationShare,
                            stationBsPrice: item.station.bsPrice
                        }));
                    }).finally(() => this.orderStationsLoading = false);
            } else {
                if (this.form.id) {
                    this.updateStationsList();
                } else {
                    this.orderStations = []; 
                }
            }
        },

        packageChangeTV() {
            if (this.form.orderType.shortName == 'TV') {
                if (this.form.grpSaleTypeId == '1') {
                    if (this.form.budget == 0.1){
                        this.form.grpSaleTypeId = '2';
                        this.form.budget = 0.2;
                        this.form.grpSaleTypeId = '1';
                    } else if (this.form.budget == 0.2){
                        this.form.grpSaleTypeId = '2';
                        this.form.budget = 0.1;
                        this.form.grpSaleTypeId = '1';
                    }
                } else {
                    if (this.form.priceMethod == 'budget'){
                        this.form.budget = 0;
                    } else if (this.form.priceMethod == 'grp'){
                        this.form.grp = 0;
                    }
                }
            }
        },

        packageChangeOOH() {
            if (this.form.orderType.shortName == 'OOH') {
                if (this.form.priceMethod == 'budget'){
                    this.form.budget = 0;
                } else if (this.form.priceMethod == 'grp'){
                    this.form.grp = 0;
                }
            }
        },

        packageChangeInternet() {
            if (this.form.orderType.shortName == 'Internet' || this.form.orderType.shortName == 'DA') {
                if (this.form.priceMethod == 'budget'){
                    this.form.budget = 0;
                } else if (this.form.priceMethod == 'grp'){
                    this.form.grp = 0;
                }
            }
        },

        loadConditions(clearFields = false) {
            if (this.form.spotTypeId) {
                const validFrom = this.formatToIsoDate(this.common.validFrom);
                const validTo = this.formatToIsoDate(this.common.validTo);
                return conditionsEndpoint.get(this.form.id, this.common.agencyId, this.common.clientId,
                    this.form.orderType.shortName, this.form.spotTypeId, validFrom, validTo)
                    .then(result => {
                        this.packageTypes = result.data;
                    })
                    .finally(() => {
                        if (clearFields && !this.loading) {
                            if (this.form.orderType.shortName == OrderType.Radio) {
                                this.form.packageTypeId = Object.keys(
                                    this.packageTypes)
                                .map(item => this.packageTypes[item])
                                .find(item => item.packageType.shortName
                                    == PackageTypeShortName.Zlecenie_indywidualne)?.packageType.valueId;
                            }
                        }
                        this.$nextTick(() => {
                            this.synchronize();
                        });
                    })
                    .catch(() => this.packageTypes = null);
            }
        },
        isValid() {
            return !this.$v.$invalid;
        },
    }
}
